module.exports = __webpack_public_path__ + "img/Jpica.89d2c97e.png";